<template>
  <div class="cxfy_2_001">
    <div class="search-box">
        <div class="left">
            <div class="top-content base-content" >
                <div class="item">
                    <div class="label" >房屋地址:</div>
                    <div class="value">
                        <Input clearable v-model="params.dz" placeholder="请输入..." style="width: 300px" />
                    </div>
                </div>
                <div class="item">
                    <div class="label" >收房门店:</div>
                    <div class="value">
                        <Select clearable v-model="params.sfmd" placeholder="请选择...">
                            <Option v-for="item in ['总部','汉中门店','长白街店','珠江路店','石鼓路店','福建路店','西家大塘','运营部','测试门店']" :key="item" :value="item">{{item}}</Option> 
                        </Select>
                    </div>
                </div> 
                <div class="item">
                    <div class="label" >收房人:</div>
                    <div class="value">
                        <Input clearable v-model="params.sfr" placeholder="请输入..." style="width: 300px" />
                    </div>
                </div>
               
            </div>
            <div class="top-content base-content" >
               
                <div class="item">
                    <div class="label" >是否更换收房人:</div>
                    <div class="value">
                        <Select clearable v-model="params.sfghsfr" placeholder="请选择...">
                            <Option v-for="item in ['是','否']" :key="item" :value="item">{{item}}</Option> 
                        </Select>
                    </div> 
                </div>
             
            </div>

        </div>
        <div class="right"> 
            <Button type="defaultdefault"   icon="ios-close-circle-outline"    @click="clear" class="btn">清空</Button>
            <Button type="primary"   icon="ios-search"    @click="init" class="btn">查询</Button> 
        </div> 
    </div> 
    <div class="operate-box"> 
        
        <Button type="warning" ghost   icon="md-code-download"    @click="add" class="btn">导出</Button>  
        <Button type="success"   icon="ios-add-circle-outline"    @click="add" class="btn">新增</Button> 
        
    </div>
    <div class="data-box">
         <Table border :columns="columns" :data="houseList" class="table-class" :width="screenWidth*0.85" :height="screenHeight*0.7">
            <template #action="{ row, index } " >
                <div class="buttomGroup">
                    <div class="btn ck" @click="watchDetail(row)">查看</div>
                  
                    <div class="btn th" @click="otherOperate(row)">业务</div>
                    <!-- <div class="btn ck" @click="watchDetail(row)">查看</div> -->
                    <!-- <div class="btn tj" @click="updateInfo(row)">修改</div>
                
                    <div class="btn th" @click="otherOperate(row)">业务</div>
                -->
                    <!-- <div class="btn tg dc" @click="exportData(row.id)">导出</div> -->
                </div>
            </template>
         </Table>
        <div class="page-line">
            <Page :total="pageSetting.total" :page-size="pageSetting.pageSize" @on-page-size-change="pageSizeChange"
            @on-change="pageChange" show-elevator show-sizer show-total></Page>
        </div>
      
    </div>
    <detail-modal ref="detail" :house-detail="houseDetail" :key-list="keyList" :photo-key-list="photoKeyList" :other-key-list="otherKeyList"></detail-modal>
   
    <add-house-modal ref="addHouse"></add-house-modal>
    <update-house-modal ref="updateHouse" :house="houseDetail" @init="init"></update-house-modal>
    <other-operate-modal ref="otherOperate" :house-detail="houseDetail" :current-data="currentData" @init="init"></other-operate-modal>
  </div>
</template>

<script>
    import {zfglMethod_2_001} from "@/api/2租房管理/2_001_cxfy.js";
    // import detailModal from '../../base_detail_modal/base_detail_modal.vue'
      import detailModal from '../../base_detail_modal/base_detail_modal.vue'
    import addHouseModal from '../../base_detail_modal/add_house_modal/add_house_modal.vue'
    import updateHouseModal from '../../base_detail_modal/update_house_modal/update_house_modal.vue'
     import otherOperateModal from '@/views/bggl/components/base_detail_modal/other_operate_modal_2_007/other_operate_modal_2_007.vue'
export default {
  name:"topUser",
  components:{detailModal, addHouseModal,updateHouseModal,otherOperateModal},
  created(){
        // this.initializeData()
        // console.log("screenWidth==",screenWidth)
        this.init()
    },
    computed: {
        screenWidth() {
            return this.$screenWidth;
        },
        screenHeight() {
            return this.$screenHeight;
        },
    },
    data() {
        return {
     
            params:{
                dz:"",//房屋地址
                sfr:"",//收房人
                sfmd:"",//收房门店
                ywzt:"待出租",//业务状态，  
                htqzsj:null,//合同起止时间
                sfghsfr:"",//是否更换收房人
                htStart:"",htEnd:"",//拆分为start和end时间
              
            },

            columns:[
                // {title: '序号', type: 'index', width: 60, align: 'center'},
                {title: '房屋地址', key: 'houseAddress', width: 300, align: 'center',fixed:"left"},
                {title: '到期预警', key: '到期预警', width: 200, align: 'center'},
                {title: '所在区', key: '所在区', width: 200, align: 'center'},
                {title: '户型', key: '户型', width: 200, align: 'center'},
                {title: '出房指导价', key: '出房指导价', width: 200, align: 'center'},
                {title: '收房租金(元/月)', key: 'receivingRent', width: 200, align: 'center'},
                {title: '收房人', key: '收房人', width: 200, align: 'center'},
                {title: '收房人', key: 'receiver', width: 150, align: 'center'},
                {title: '收房门店', key: 'receivingStore', width: 200, align: 'center'},
                {title: '物业费(元/月)', key: 'strataFees', width: 200, align: 'center'},
                {title: '空置天数', key: '空置天数', width: 200, align: 'center'},
                {title: '上架时间', key: '上架时间', width: 200, align: 'center'},
                {title: '朝向', key: '朝向', width: 200, align: 'center'},
                {title: '面积(平米)', key: 'area', width: 200, align: 'center'},

                {title: '操作', slot: 'action', width: 200, align: 'center',fixed:"right"},

            ],
            keyList:[
                "共", "卫", "厅", "户型", "押金","所在区",
                "朝向", "气卡", "水卡", "用途", "电卡",
                "合同ID", "房源ID", "丘权号", "免租期", "可整租",
                "开户行", "收房人", "上架时间", "业务状态", "创建时间",
                "到期预警", "剩余房间", "合同状态",
                "合同编号",  "小区名称", "房东姓名", "房东电话",
                "房东编号", "房屋地址", "所在小区", "支付周期", "支付户名",
                "收房渠道", "收房费用", "收房门店", "楼层信息", "物业费元",
                "空置天数", "装修天数", "装修状态", "送达地址", "配套设施",
                "银行卡号", "不动产权号", "免租期备注", "出房指导价",
                "合同到期日", "合同起始日", "小程序状态", "待租空置期", "总空置天数",
                "收房指导价", "电卡用户名", "维修空置期", "缴费卡信息", "装修空置期",
                "免租期（天）", "收房违约收入", "面积（平米）", "收房租金（元/月）", "第三年免租期（天）",
                "第二年免租期（天）",
               
                ],
            photoKeyList:[ "客厅照片","卧室照片", "厨房照片", "卫生间照片",],
            otherKeyList:[
                "其他卡", "套内建筑面积", "出租部位", "是否更换收房人", "委托人电话",
                "街道办", "备注2", "楼号", "建成年代", "是否开通燃气",
                "指导月租金", "出租间套数", "业务序号",  "出租方式",
                "是否可同步", "钥匙/密码", "权属证明编号", "院门牌号", "首页推荐",
                "封面照片", "接收状态", "其他照片", "备注",
                "装修标准", "出租用途", "特别约定", "授权委托书", 
                "房源标签", "中止日期", "装修后照片", "业务员编号", "房屋原貌",
                "坐落", "房源分类", "房源简介", "装修图片", "装修视频",
                "离职分配", "室号", "房源类型", "说明", "权属证明名称",
                "地铁线", "受托代理人姓名", "路街巷", "合同中止时间", "临街状态",
                "产权人身份证号", "交房日期", "产权性质", "公示坐落", "不动产单元号",
                "房源标题", "中止原因"
            ],
            //单独拿出来
            //房屋托管合同信息  产证信息 身份证信息

            pageSetting:{
                pageSize: 15,
                pageIndex: 1,
                total: 0
            },
            houseList:[

            ],
            houseDetail:{},//单个房源详情
            currentData:{},//当前row
        }
    },
    
    mounted(){  },
    watch:{},
    methods:{
        init(){
            console.log("params===",this.params)
            let params=this.params
            params.pageSize=this.pageSetting.pageSize
            params.pageIndex=this.pageSetting.pageIndex
            zfglMethod_2_001.selectList(params).then((res)=>{
                console.log("res===",res)
                res.data.houseList.forEach((i)=>{
                    // i.contractStartDate = this.formatTimestamp(i.contractStartDate )
                    // i.contractEndDate = this.formatTimestamp(i.contractEndDate )
                })
                this.$nextTick(()=>{
                    this.houseList=res.data.houseList
                    this.pageSetting.total=res.data.total 
                    // this.watchDetail({id:"60a23c03e4b0bcb167f69b2e:60f685a3e4b0ce8c613253fc"})
                })
                

            })
        },
        // 查看详情
        watchDetail(row){
            let params={
                id:row.id
            }
            zfglMethod_2_001.getById(params).then((res)=>{
                console.log("detail==res===",res)
                this.houseDetail=res.data 
                this.$refs.detail.detailModal=true
                // this.$nextTick(()=>{
                //     this.$refs.detail.detailModal=true
                // })

            })
        },
          // 修改非附件信息
          updateInfo(row){
            let params={
                id:row.id
            }
            zfglMethod_2_001.getByIdforUpdate(params).then((res)=>{
            
                this.houseDetail=res.data 
                // console.log("houseDetail===",this.)
                this.$refs.updateHouse.updateModal=true
               
            })
        },
        // 逻辑删除
        deleteRecord(row){
            let _this=this
            this.$Modal.confirm({
              title: '确认删除提醒',
              content: `<br>请注意，点击确认后不可撤回<br>`,
              onOk(){
                let param={id:row.id}
               
                zfglMethod_2_001.deleteRecord(param).then((res)=>{
                  console.log("删除——res====",res)
                  if(res.data.deleteRes!=0 && res.data.deleteRes!=null){
                    _this.$Message.success("删除成功！")
                    _this.init() 
               
                  }
                })


              }})
       
        },
        // 修改业务状态
        updateYwzt(row,isPass){
            let _this=this
            this.$Modal.confirm({
              title: '确认修改提醒',
              content: `<br>请注意，点击确认后不可撤回<br>`,
              onOk(){
                let param=row
                param.isPass=isPass
                zfglMethod_2_001.updateYwzt(param).then((res)=>{
                  console.log("修改业务状态——res====",res)
                  console.log("res.data.msg====",res.data.msg)
                   if(res.data.msg!=""&&res.data.msg!=null){
                    _this.$Message.warning({
                        content:res.data.msg,
                        duration:6
                    })
                    _this.init() 
                   }else{
                    if(res.data.updateRes>0){
                        _this.$Message.success("操作成功")
                        _this.init() 
                    }
                   }
                   
               
                   
                })


              }})
        },
        // 其他业务
        otherOperate(row){
            let params={
                id:row.id
            }
            this.currentData=row
            zfglMethod_2_001.getById(params).then((res)=>{
                console.log("detail==res===",res)
                this.houseDetail=res.data 
                this.$nextTick(()=>{
                    this.$refs.otherOperate.otherModal=true
                  
                    this.$refs.otherOperate.changeIllustrate("预定")
                })

            })
         
        },
        // 新增
        add(){
            this.$refs.addHouse.modal=true
        },
        clear(){
            this.params={
                fwdz:"",//房屋地址
                sfr:"",//收房人
                sfmd:"",//收房门店
                ywzt:"",//业务状态
                htqzsj:null,//合同起止时间
                htStart:"",htEnd:"",//拆分为start和end时间
                pageSize:15,
                pageIndex:1,
            }
            this.init()
        },
        pageSizeChange(i) {
            this.pageSetting.pageSize = i;
            this.init()
        },
        pageChange(i) {
            this.pageSetting.pageIndex = i;
            this.init()
        },
        changeDate(date){
            // console.log("date==",date)
            this.params.htStart=date[0]
            this.params.htEnd=date[1]
        },
        formatTimestamp(timestamp) {
            const date = new Date(timestamp);
            console.log("date==",date)

            // 获取年月日时分秒
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');

            // 拼接成 "YYYY-MM-DD HH:mm:ss" 格式
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
    }


}
</script>

  
  <style lang="scss" >
@import '2_007_cf_dcz.scss'; 

  </style>